import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="logo">
        <NavLink to="/" onClick={closeMenu}>
          <img src="/logo.png" alt="RelyOnne UK Logo" />
        </NavLink>
      </div>

      {/* Mobile Menu Button */}
      <button
        className={`menu-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`nav ${menuOpen ? "mobile-open" : ""}`}>
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          Home
        </NavLink>

        <NavLink
          to="/who-we-are"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          Who We Are
        </NavLink>

        <NavLink
          to="/what-we-do"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          What We Do
        </NavLink>

        <NavLink
          to="/products"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          Products
        </NavLink>

        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={closeMenu}
        >
          Contact
        </NavLink>
      </nav>
    </header>
  );
}

export default Header;